import { inject, Injectable, signal ,computed} from "@angular/core";
import { firstValueFrom } from "rxjs";
import { AppConfig } from "@api/models/app-config";
import { HttpClient } from "@angular/common/http";

@Injectable({
    providedIn: "root"
})
export class AppConfigService {
    private readonly _http = inject(HttpClient);

    appConfig = signal<AppConfig>({} as AppConfig); // I know better than the type checker

    configLoaded = computed(() => {
    // Check if a key config value exists
    return !!this.appConfig()?.appInsightsConnectionString;
    });

    async initialize(): Promise<void> {
        this.appConfig.set(await firstValueFrom(this._http.get<AppConfig>("/config.json")));
    }
}